import { render } from "./AddEquipageModalPage.vue?vue&type=template&id=2d225501&ts=true"
import script from "./AddEquipageModalPage.vue?vue&type=script&lang=ts"
export * from "./AddEquipageModalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__